export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
                d="M26.8333 11.6665H9.33333C8.04467 11.6665 7 12.7112 7 13.9998V41.9998C7 43.2885 8.04467 44.3332 9.33333 44.3332H46.6667C47.9553 44.3332 49 43.2885 49 41.9998V38.4998"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M37.3914 25.6665C41.2574 25.6665 44.3914 22.5325 44.3914 18.6665C44.3914 14.8005 41.2574 11.6665 37.3914 11.6665C33.5255 11.6665 30.3914 14.8005 30.3914 18.6665C30.3914 22.5325 33.5255 25.6665 37.3914 25.6665Z"
                stroke="#F7A40A"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M49.0581 33.155C46.7794 28.7025 42.058 25.6665 37.3913 25.6665C32.7247 25.6665 30.3997 26.9882 28 29.1665"
                stroke="#F7A40A"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16.3333 23.3335H23.3333" stroke="black" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M16.3333 35H39.6667" stroke="black" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
}
